/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Flex, Box, Text, Link } from '@tishman/components';
import * as Icons from '@tishman/icons';
import React, { useState, useMemo } from 'react';

type AlertQuery = {
  alert: Queries.Maybe<Queries.SanityAlert>;
};

const AlertBanner = (props: {
  data?: {
    alert?: AlertQuery;
  };
}): JSX.Element | null => {
  const alert = props.data?.alert?.alert;
  const [bannerIsVisible, toggleBannerVisible] = useState<boolean>(true);

  const alertBannerProps = useMemo(() => {
    return {
      title: alert?.title,
      description: alert?.description,
      type: alert?.type,
      url: alert?.link?.url,
      caption: alert?.link?.caption,
    };
  }, [alert]);

  const { title, description, url, caption, type } = alertBannerProps;

  if (!title) return null;

  if (description && !title) return null;

  return (
    <Box sx={{ pointerEvents: 'auto' }}>
      {bannerIsVisible && (
        <Flex
          sx={{
            backgroundColor: type === 'Live' ? '#FFD758' : '#89CBDB',
            padding: ['15px', '15px 34px'],
          }}
        >
          <Flex
            sx={{
              flex: 1,
              justifyContent: 'center',
              flexDirection: ['column', 'row'],
              alignItems: ['center'],
            }}
          >
            <Text
              sx={{
                fontWeight: 500,
                whiteSpace: ['pre-line', 'pre-line', 'pre-line', 'normal'],
                textAlign: 'center',
              }}
              variant="smallP"
            >
              {title}
            </Text>
            <Text
              sx={{ ml: 1, textAlign: 'center', fontWeight: 400 }}
              variant="smallP"
            >
              {description}
            </Text>
            <Link href={`${url}`} sx={{ ml: 1, color: 'white' }}>
              <Text
                sx={{ fontWeight: 500, textDecorationColor: 'white' }}
                variant="smallP"
              >
                {caption}
              </Text>
            </Link>
          </Flex>
          <Flex
            sx={{
              justifyContent: 'flex-end',
              cursor: 'pointer',
              margin: [0, 'auto'],
            }}
          >
            <Icons.CloseAlert
              onClick={() => toggleBannerVisible(!bannerIsVisible)}
            />
          </Flex>
        </Flex>
      )}
    </Box>
  );
};

export default AlertBanner;
